import type {
  AplusFragmentFragment,
  PriceCurrency,
} from '@packages/gql/generated/shopping/graphql';
import type { APlusItems } from '@packages/modules/src/APlus/types';

export const transformBasketAplusToItems = (
  clusters: AplusFragmentFragment['clusters'],
): { items: APlusItems; currency: PriceCurrency } => {
  const items: APlusItems = [];
  let currency: PriceCurrency = 'EUR' as PriceCurrency;

  for (const cluster of clusters) {
    for (const service of cluster.services) {
      if (service.price.currency) {
        currency = service.price.currency;
      }
      items.push({
        uuid: service.uuid,
        serviceIcon: service.serviceIcon,
        serviceLayerId: `a-plus_${service.uuid}`,
        clusterLabel: cluster.label,
        mandatory: Boolean(service.included),
        free: Boolean(service.included) || service.price.value === 0,
        preselected: Boolean(service.selected),
        name: service.name,
        price: service.price.value / 100,
        serviceCount: service.serviceCount
          ? { current: service.serviceCount.current, maximum: service.serviceCount.maximum }
          : undefined,
      });
    }
  }

  return { items, currency };
};
